<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"  >
  <p style="font-size: 20px; color: white">{{'messages.loadingList' | translate}}</p>
</ngx-spinner>
<div class="main-content">
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="mb-0 font-size-18">
              <i class="bx bx-home-circle"></i>  {{'dashboard.welcome' | translate}}
              <app-fildariane></app-fildariane>
            </h4>
            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item"><a href="javascript: void(0);">{{'navigation.home' | translate}}</a></li>
                <li class="breadcrumb-item active">{{'pages.manageCertificates' | translate}}
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
      <div class="row align-items-center" style="margin-bottom: 20px">
        <div class="col-auto">
          <a href="/dashboard/administrator/certification/ajouter">
            <button type="button" class="btn btn-primary waves-effect waves-light">
            <i class="bx bx-plus font-size-16 align-middle mr-2"></i> {{'common.add' | translate}}
          </button></a>
        </div>
        <div class="col text-right">
          <button type="button" class="btn btn-primary waves-effect waves-light" (click)="exporter()">
            <i class="bx bx-export font-size-16 align-middle mr-2"></i> {{'common.export' | translate}}
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{'common.filter' | translate}}</h4>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>{{'fields.site' | translate}}</label>
                    <select class="custom-select" [(ngModel)]="site_id" (change)="filterSite($event.target.value)">
                      <option selected="788">{{'messages.selectSite' | translate}}</option>
                      <option value="7xxx7">{{'common.all' | translate}}</option>
                      <option *ngFor="let site of list_sites" value="{{site.id}}">{{site.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>{{'fields.theme' | translate}}</label>
                    <select class="custom-select" [(ngModel)]="theme_filter" (change)="filterTheme($event.target.value)">
                      <option value="">{{'common.all' | translate}}</option>
                      <option *ngFor="let theme of themes" [value]="theme">{{theme}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>{{'fields.articleCode' | translate}}</label>
                    <input class="form-control" type="text" [(ngModel)]="code_article_filter" (input)="filterCodeArticle($event.target.value)" [placeholder]="'common.search' | translate">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="alert alert-success text-center" role="alert" *ngIf="addingSuccess">
            {{'messages.actionCompletedWith' | translate}} <a href="#" class="alert-link">{{'messages.success' | translate}}</a>
            <button type="button" class="close" data-dismiss="alert" [attr.aria-label]="'common.close' | translate">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div id="accordion">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{'pages.listCertifications' | translate}} ({{count_certificat}})</h4>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead>
                  <tr>
                    <th [class.active]="order === 'certificat.id'"
                        (click)="setOrder('certificat.id')">{{'fields.ckCode' | translate}}
                      <span [hidden]="reverse">▼</span
                      ><span [hidden]="!reverse">▲</span></th>
                    <th>{{'fields.theme' | translate}}</th>
                    <th *ngIf="entityType == 'EKAMPUS'">{{'fields.site' | translate}}</th>
                    <th>{{'fields.clientCode' | translate}}</th>
                    <th>{{'fields.articleCode' | translate}}</th>
                    <th [class.active]="order === 'certificat.name'"
                        (click)="setOrder('certificat.name')">{{'fields.label' | translate}}
                      <span [hidden]="reverse">▼</span
                      ><span [hidden]="!reverse">▲</span></th>
                    <th>{{'fields.validityDuration' | translate}}</th>
                    <th>{{'common.actions' | translate}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let certificat of certificats | orderBy: order:reverse:false ; let i = index ">
                    <td scope="row">
                      <p>
                        <a data-toggle="collapse" href="#collapse_{{certificat.id}}" role="button" aria-expanded="false"  data-target="collapse_{{certificat.id}}"  (click)="listingSousCertificat(certificat.id)">
                          <span class="caret" *ngIf="certificat.subCertCodes?.length > 0"></span>{{certificat.code_cert}}
                        </a>
                      </p>
                      <div class="collapse" id="collapse_{{certificat.id}}" data-parent="#accordion" >
                        <ng-container *ngIf="certificat.id === certId">
                        <ul class="tree">
                          <span *ngIf="showLoader"><img src="../../../../assets/img/loaderkapi.gif" height="12"></span>
                          <ng-container *ngIf="showLabel">
                            <li *ngFor="let certif of list_certificat">
                              {{certif.code_cert}}
                           </li>
                          </ng-container>
                        </ul>
                        </ng-container>
                      </div>
                    </td>
                    <td>
                      {{certificat.theme}}
                    </td>
                    <ng-container *ngIf="entityType == 'EKAMPUS'">
                      <td>
                        {{certificat.siteNames}}
                      </td>
                    </ng-container>
                    <td>
                      {{certificat.code_client}}
                    </td>
                    <td>
                      {{certificat.code_article}}
                    </td>
                    <td>
                      <a data-toggle="collapse" href="#collapse_{{certificat.id}}" role="button" aria-expanded="false"  data-target="collapse_{{certificat.id}}"  (click)="listingSousCertificat(certificat.id)">
                      <span class="caret" *ngIf="certificat.subCertCodes?.length > 0"></span>{{certificat.name}}
                      </a>
                    </td>
                    <td>
                      {{certificat.type_validite == 2 ? (certificat.delay + ' mois') : certificat.date}}
                    </td>
                    <td class="action-icons">
                      <i class="bx bx-edit-alt action-icon action-icon-edit" [attr.title]="'common.edit' | translate" (click)="editer(certificat.id)"></i>
                      <i class="bx bx-trash-alt action-icon action-icon-delete" [title]="'common.delete' | translate" (click)="supprimer(certificat.id)"></i>
                      <i class="bx bx-check-shield action-icon action-icon-verif" [title]="'navigation.verifications' | translate" (click)="verifications(certificat.id)"></i>
                    </td>
                  </tr>
                  </tbody>
                </table>

              </div>

            </div>
          </div>
          </div>
        </div>

        <!-- end row -->
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>
  </div>
</div>
  <!-- End Page-content -->
  <app-footer></app-footer>


